import JsonApi from 'devour-client';
import _ from 'lodash';

import responseMiddleware from '@/utils/devour/res-middleware';
import errorMiddleware from '@/utils/devour/error-middleware';

import store from '@/store';

const jsonApi = new JsonApi({
  apiUrl: process.env.VUE_APP_API_URL,
});

jsonApi.replaceMiddleware('errors', errorMiddleware);
jsonApi.replaceMiddleware('response', responseMiddleware);

jsonApi.auth = () => {
  jsonApi.bearer = store.getters['app/authToken'];
};

const jsonApiType = (name) => {
  return `${_.kebabCase(name)}s`;
};

export function filterAttributes(attributes, data) {
  const keys = Object.keys(attributes);
  keys.push('id');
  return _.pick(data, keys);
}

export function filterRelationships(relationships, data) {
  const keys = Object.keys(relationships);
  const justGoodData = _.pick(data, keys);

  return _.mapValues(justGoodData, (value, key) => {
    return { id: value, type: jsonApiType(key) };
  });
}

export default jsonApi;
